// with-context.ts — defineComponent-Mixin über der ContextBinding (PFS-666).
//
// Für pfs-components-interne WCs, die an einen Context-Wert gebunden sind: hängt eine
// ContextBinding in den Mixin-Lifecycle und ruft `render(value, host, shadowRoot)` bei
// connect + jeder echten Wert-Änderung. Cut-App-Domänen-WCs (normale Klassen) HALTEN
// stattdessen direkt eine ContextBinding — dieselbe Maschine, ohne defineComponent-Zwang.
import type { Mixin } from "./define-component.js";
import { ContextBinding } from "./context-binding.js";

export interface WithContextOptions {
  key: string;
  scopeAttr?: string;
  render: (value: string | null, host: HTMLElement, shadowRoot: ShadowRoot | null) => void;
}

export function withContext(opts: WithContextOptions): Mixin {
  return (host, ctx) => {
    const binding = new ContextBinding(host, {
      key: opts.key,
      scopeAttr: opts.scopeAttr,
      onResolve: (value) => opts.render(value, host, ctx.shadowRoot),
    });
    return {
      connect() {
        binding.connect();
      },
      disconnect() {
        binding.disconnect();
      },
    };
  };
}
